import { useEffect, useRef } from "react";

/**
 * This hook helps set up a function that will be called whenever
 * the specific event is delivered to the window object.
 */
export const useWindowEventListener = <EventType extends Event>(
    type: string,
    event: (event: EventType) => void | Promise<void>,
    dependencies: unknown[] = [],
    allowDuplicated = false
) => {
    const eventListener = useRef<EventListener>();

    useEffect(() => {
        if (!allowDuplicated && eventListener.current) {
            window.removeEventListener(type, eventListener.current);
            eventListener.current = undefined;
        }

        eventListener.current = event as EventListener;
        window.addEventListener(type, eventListener.current);

        return () => {
            if (eventListener.current) {
                window.removeEventListener(type, eventListener.current);
                eventListener.current = undefined;
            }
        };
    }, dependencies);
};
